export default __webpack_public_path__ + "locales/pl/DeleteThirdPartyDialog.json?hash=5e0b953091c4450e64678a6ddc68ed51";